// extracted by mini-css-extract-plugin
export default {"root":"GroupFeed_root__s0eGt"};